// Flat { [roomName]: included } map of every room; the root (base room) counts as included.
export function collectIncludedFlags(hierarchy) {
  const flags = {};

  const collect = (nodes = {}, isRoot = false) => {
    Object.entries(nodes).forEach(([name, node]) => {
      flags[name] = isRoot ? true : node.included;
      collect(node.children);
    });
  };

  collect(hierarchy, true);

  return flags;
}

// Copy the prefill hierarchy and apply the known include flags; rooms without a flag keep their prefill value.
export function carryOverIncludedFlags(prefillHierarchy, includedFlagsByRoom) {
  // Deep copy so the cached prefill object is never mutated
  const hierarchy = JSON.parse(JSON.stringify(prefillHierarchy));

  const applyFlags = (children = {}) => {
    Object.entries(children).forEach(([name, node]) => {
      if (Object.hasOwn(includedFlagsByRoom, name)) {
        node.included = includedFlagsByRoom[name];
      }
      applyFlags(node.children);
    });
  };

  applyFlags(Object.values(hierarchy)[0].children);

  return hierarchy;
}
